import { inject, InjectionToken } from '@angular/core';

import { WINDOW } from './window';

export const LOCATION = new InjectionToken<Location>(
  'window.location object',
  {
    factory: (): Location => inject(WINDOW).location,
  },
);
